import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "login" }
const _hoisted_3 = {
  key: 0,
  class: "pulse-dot-wrapper"
}
const _hoisted_4 = {
  key: 0,
  class: "welcome-text"
}
const _hoisted_5 = { class: "user-info" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "pulse-dot"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 0,
  class: "error"
}
const _hoisted_11 = {
  key: 1,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelloWorld = _resolveComponent("HelloWorld")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HelloWorld, { msg: "Welcome to FireAds App" }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showDot)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "pulse-dot" }, null, -1)
          ]))]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isLoggedIn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[5] || (_cache[5] = _createTextVNode(" Welcome back! ", -1)),
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.user)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.user), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7))
                  ]),
                  _createElementVNode("button", {
                    class: "logout-btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, "Sign out")
                ]))
              : (_openBlock(), _createElementBlock("form", {
                  key: 1,
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { for: "email" }, "Email:", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      id: "email",
                      name: "email",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", { for: "password" }, "Password:", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      id: "password",
                      name: "password",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ])
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("button", { type: "submit" }, "Sign in", -1)),
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
                    : _createCommentVNode("", true),
                  (_ctx.logoutError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Sign out with errors"))
                    : _createCommentVNode("", true)
                ], 32))
          ], 64))
    ])
  ]))
}